import React from 'react';
import { Button, ButtonProps } from '@atoms/Button/Button';
import {
  CallToActionCardProps,
  CallToActionCard,
} from '@molecules/CallToAction/CallToActionCard';
import { FormTitle } from '@molecules/FormTitle/FormTitle';
import {
  NavigationLink,
  NavigationLinkObject,
} from '@molecules/NavigationLink/NavigationLink';

interface BeforeYouStartTemplateProps {
  contentTitle: string;
  contentSubtext?: string | React.ReactNode;
  loginButton?: ButtonProps;
  callToActionCards: CallToActionCardProps[];
  linkObjectArrays: NavigationLinkObject[];
  additionalContent?: string | React.ReactNode;
}

export const BeforeYouStartTemplate: React.FC<BeforeYouStartTemplateProps> = ({
  contentTitle,
  contentSubtext,
  loginButton,
  callToActionCards,
  linkObjectArrays,
  additionalContent,
}) => {
  return (
    <form className="text-text-body flex flex-col">
      <section
        data-testid="before-you-start-content"
        className="bg-accent-grey section-horizontal-padding -section-horizontal-margin flex flex-col pb-3"
      >
        <div className="py-2">
          <NavigationLink linkObjectArrays={linkObjectArrays} />
        </div>
        <hr className="border-ui-border border-1 w-full" />
        <FormTitle text={contentTitle} titleSize="extraLarge" />
      </section>
      <div className="max-w-form my-4 flex flex-col items-start gap-8">
        {contentSubtext}
        {loginButton ? (
          <Button
            data-testid="login-button"
            variant="primary"
            label={loginButton.label}
            onClick={loginButton.onClick}
            {...loginButton}
          />
        ) : null}
      </div>
      <section
        className="my-5 flex w-full flex-col items-start space-y-4"
        data-testid="navigate-to-form"
      >
        {callToActionCards.map((card) => {
          return <CallToActionCard {...card} key={card.linkText} />;
        })}
      </section>
      {additionalContent ? (
        <section
          className="my-5 flex w-full flex-col items-start space-y-4"
          data-testid="additional-content"
        >
          {additionalContent}
        </section>
      ) : null}
    </form>
  );
};
